var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-timeline",class:( _obj = {}, _obj[_vm.extraClass] = !!_vm.extraClass, _obj )},[_c('div',{staticClass:"v-timeline__status-track"},_vm._l((_vm.items),function(item){
var _obj;
return _c('div',{class:( _obj = {}, _obj[item.status] = !!item.status, _obj )},[_c('img',{attrs:{"src":_vm.getImgSrc(item.status),"alt":"dot"}}),_c('label',[_vm._v(_vm._s(item.title))]),(item.status !== 'future')?_c('span',{staticClass:"extra"},[_vm._v("\n        "+_vm._s(item.time))]):_vm._e()])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }